import { useState } from 'react'

import { EMPTY_LIST } from '../../constants/common'

export function useSelection({
  config = { itemIdKey: 'id' },
  data,
  pagination,
}) {
  const { itemIdKey } = config

  const [selected, setSelected] = useState(EMPTY_LIST)
  const [exclude, setExclude] = useState(EMPTY_LIST)
  const [selectAllPages, setSelectAllPages] = useState(false)

  const items = data?.items || EMPTY_LIST

  const isAllSelected =
    items.length > 0 &&
    ((selected.length > 0 &&
      items.every(item =>
        selected.find(
          selectedItem => selectedItem[itemIdKey] === item[itemIdKey]
        )
      )) ||
      (selectAllPages &&
        items.every(
          item =>
            !exclude.find(
              excludeItem => excludeItem[itemIdKey] === item[itemIdKey]
            )
        )))

  const isRemoveSelection =
    !isAllSelected &&
    items.length > 0 &&
    ((selectAllPages &&
      items.some(item =>
        exclude.find(excludeItem => excludeItem[itemIdKey] === item[itemIdKey])
      ) &&
      !items.every(item =>
        exclude.find(excludeItem => excludeItem[itemIdKey] === item[itemIdKey])
      )) ||
      items.some(item =>
        selected.find(
          selectedItem => selectedItem[itemIdKey] === item[itemIdKey]
        )
      ))

  const excludeIds = exclude.map(item => item[itemIdKey])

  const selectedIds = selected.map(item => item[itemIdKey])

  function handleSelect(item, isChecked) {
    if (isChecked) {
      setSelected(prevSelected => [...prevSelected, item])
    } else {
      setSelected(prevSelected =>
        prevSelected.filter(
          selectedItem => selectedItem[itemIdKey] !== item[itemIdKey]
        )
      )
    }
  }

  function handleExcludeAndUpdateSelectAllPages(newExclude) {
    if (newExclude.length >= pagination?.count) {
      setSelectAllPages(false)
      setExclude(EMPTY_LIST)
    } else {
      setExclude(newExclude)
    }
  }

  function handleExclude(item) {
    if (
      exclude.find(excludeItem => excludeItem[itemIdKey] === item[itemIdKey])
    ) {
      setExclude(prevExclude =>
        prevExclude.filter(
          excludeItem => excludeItem[itemIdKey] !== item[itemIdKey]
        )
      )
    } else {
      handleExcludeAndUpdateSelectAllPages([...exclude, item])
    }
  }

  function handleSelectAll() {
    const hasSelectedOnPage = items.some(item =>
      selected.find(selectedItem => selectedItem[itemIdKey] === item[itemIdKey])
    )
    const itemsIds = items.map(item => item[itemIdKey])

    if (!selectAllPages && hasSelectedOnPage) {
      setSelected(prevSelected => {
        return prevSelected.filter(
          selectedItem => !itemsIds.includes(selectedItem[itemIdKey])
        )
      })
    } else if (selectAllPages) {
      if (
        items.every(item =>
          exclude.find(
            excludeItem => excludeItem[itemIdKey] === item[itemIdKey]
          )
        )
      ) {
        handleExcludeAndUpdateSelectAllPages(
          exclude.filter(
            excludeItem => !itemsIds.includes(excludeItem[itemIdKey])
          )
        )
      } else if (
        items.some(item =>
          exclude.find(
            excludeItem => excludeItem[itemIdKey] === item[itemIdKey]
          )
        )
      ) {
        const excludedItems = items.filter(
          item =>
            !exclude.find(
              excludeItem => excludeItem[itemIdKey] === item[itemIdKey]
            )
        )

        handleExcludeAndUpdateSelectAllPages([...exclude, ...excludedItems])
      } else {
        handleExcludeAndUpdateSelectAllPages([...exclude, ...items])
      }
    } else {
      setSelected(prevSelected => [...prevSelected, ...items])
    }
  }

  function handleCleanSelection() {
    setSelected(EMPTY_LIST)
    setExclude(EMPTY_LIST)
    setSelectAllPages(false)
  }

  function handleUnselectAllPages() {
    setSelected(EMPTY_LIST)
    setExclude(EMPTY_LIST)
    setSelectAllPages(false)
  }

  function handleSelectAllPages() {
    setSelected(EMPTY_LIST)
    setExclude(EMPTY_LIST)
    setSelectAllPages(true)
  }

  function handleInitializeSelection(items) {
    setSelected(items)
  }

  function checkIsItemSelected(item) {
    return Boolean(
      (selectAllPages &&
        !exclude.find(
          excludeItem => excludeItem[itemIdKey] === item[itemIdKey]
        )) ||
      selected.find(selectedItem => selectedItem[itemIdKey] === item[itemIdKey])
    )
  }

  return {
    checkIsItemSelected,
    exclude,
    excludeIds,
    handleCleanSelection,
    handleExclude,
    handleInitializeSelection,
    handleSelect,
    handleSelectAll,
    handleSelectAllPages,
    handleUnselectAllPages,
    isAllSelected,
    isRemoveSelection,
    selectAllPages,
    selected,
    selectedIds,
  }
}
